import React from 'react';
import axios from 'axios';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import App from './app';
import reportWebVitals from './reportWebVitals';
import './index.css';

/* eslint-disable  @typescript-eslint/no-non-null-assertion */
const container = document.getElementById('root')!;
const root = createRoot(container);

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        Promise.reject(error);
    },
);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
